import { Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { FC } from 'react'

export interface CapacityTooltipContentProps {
  headline: string
  utilizationPct: number
  consumedTeu: number
  totalTeu: number
}

export const CapacityTooltipContent: FC<CapacityTooltipContentProps> = ({
  headline,
  utilizationPct,
  consumedTeu,
  totalTeu,
}) => {
  const { t } = useTranslate()

  return (
    <Stack spacing={0.25}>
      <Typography variant='body2' sx={{ fontWeight: 'medium' }}>
        {headline}
      </Typography>
      <Typography variant='caption'>
        {t('capacityTooltipUtilization', '{pct}% — {consumed}/{total} TEU', {
          pct: utilizationPct,
          consumed: consumedTeu,
          total: totalTeu,
        })}
      </Typography>
    </Stack>
  )
}
